import { render, staticRenderFns } from "./listing-description.vue?vue&type=template&id=546c50a3&scoped=true&"
import script from "./listing-description.vue?vue&type=script&lang=js&"
export * from "./listing-description.vue?vue&type=script&lang=js&"
import style0 from "./listing-description.vue?vue&type=style&index=0&id=546c50a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c50a3",
  null
  
)

export default component.exports